import React, { createContext, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import D001SearchTop from "./components/jsx/D001SearchTop";
import D002SearchResult from "./components/jsx/D002SearchResult";
import D003SearchDetail from "./components/jsx/D003SearchDetail";
import D0041ContactTop from "./components/jsx/D0041ContactTop";
import D0042ContactConfirm from "./components/jsx/D0042ContactConfirm";
import D0043ContactComplete from "./components/jsx/D0043ContactComplete";
import D00501QuestionList from "./components/jsx/D00501QuestionList";
import D00502QuestionDetail from "./components/jsx/D00502QuestionDetail";
import D00503QuestionSearchList from "./components/jsx/D00503QuestionSearchList";
import D006FirstTime from "./components/jsx/D006FirstTime";
import D007RoadMap from "./components/jsx/D007RoadMap";
import D008UpdateLog from "./components/jsx/D008UpdateLog";
import D010TermsService from "./components/jsx/D010TermsService";
import D011PrivacyPolicy from "./components/jsx/D011PrivacyPolicy";
import D0121RacTop from "./components/jsx/D0121RacTop";
import D0122RacDetail from "./components/jsx/D0122RacDetail";
import D0131FoodAdditive from "./components/jsx/D0131FoodAdditive";
import D0141OperatingOrganization from "./components/jsx/D0141OperatingOrganization";

import G009AdminLogin from "./components/jsx/G009AdminLogin";
import G010QuarantineList from "./components/jsx/G010QuarantineList";
import G011NewsList from "./components/jsx/G011NewsList";
import G012NewsEdit from "./components/jsx/G012NewsEdit";
import G0131PlantQuarantineList from "./components/jsx/G0131PlantQuarantineList";
import G0132PlantQuarantineEdit from "./components/jsx/G0132PlantQuarantineEdit";
import G0141AnimalQuarantineList from "./components/jsx/G0141AnimalQuarantineList";
import G0142AnimalQuarantineEdit from "./components/jsx/G0142AnimalQuarantineEdit";
import G0151RadioActiveList from "./components/jsx/G0151RadioActiveList";
import G0152RadioActiveEdit from "./components/jsx/G0152RadioActiveEdit";
import G016LinkMaster from "./components/jsx/G016LinkMaster";
import G017InputWord from "./components/jsx/G017InputWord";
import G0181StaffList from "./components/jsx/G0181StaffList";
import G0182StaffEdit from "./components/jsx/G0182StaffEdit";
import G0191ExportCountryList from "./components/jsx/G0191ExportCountryList";
import G0192ExportCountryEdit from "./components/jsx/G0192ExportCountryEdit";
// 残留農薬
import G0201Rac from "./components/jsx/G0201Rac";
import G0202RacItemCommon from "./components/jsx/G0202RacItemCommon";
import G0203RacCountry from "./components/jsx/G0203RacCountry";
import G0204RacStdValue from "./components/jsx/G0204RacStdValue";
import G0205RacPesticide from "./components/jsx/G0205RacPesticide";
import G0206RacProduct from "./components/jsx/G0206RacProduct";
import G0207RacExport from "./components/jsx/G0207RacExport";
import G0208RacJa from "./components/jsx/G0208RacJa";
import G0209RacEn from "./components/jsx/G0209RacEn";
import G02010RacQuarantineList from "./components/jsx/G02010RacQuarantineList";
import G02011RacQuarantineEdit from "./components/jsx/G02011RacQuarantineEdit";
import G02012RacUpload from "./components/jsx/G02012RacUpload";
import G02013RacPesticideProducts from "./components/jsx/G02013RacPesticideProducts";

// 食品添加物
import G0211FoodAdditive from "./components/jsx/G0211FoodAdditive";
import G0212EuAdditiveList from "./components/jsx/G0212EuAdditiveList";
import G0213EuFoodCategoryList from "./components/jsx/G0213EuFoodCategoryList";
import G0214EuFootnoteList from "./components/jsx/G0214EuFootnoteList";
import G0215EuFoodAdditiveList from "./components/jsx/G0215EuFoodAdditiveList";
import G0216EuCombinationList from "./components/jsx/G0216EuCombinationList";
import G0217EuQuarantineList from "./components/jsx/G0217EuQuarantineList";
import G0218EuQuarantineEdit from "./components/jsx/G0218EuQuarantineEdit";

// よくあるご質問
import G0221Question from "./components/jsx/G0221Question";
import G0222QuestionCategoryList from "./components/jsx/G0222QuestionCategoryList";
import G0223QuestionCategoryEdit from "./components/jsx/G0223QuestionCategoryEdit";
import G0224QuestionList from "./components/jsx/G0224QuestionList";
import G0225QuestionEdit from "./components/jsx/G0225QuestionEdit";

// 利用規約・免責事項
import G0231TermsServiceList from "./components/jsx/G0231TermsServiceList";
import G0232TermsServiceEdit from "./components/jsx/G0232TermsServiceEdit";

// プライバシーポリシー
import G0241PrivacyPolicyList from "./components/jsx/G0241PrivacyPolicyList";
import G0242PrivacyPolicyEdit from "./components/jsx/G0242PrivacyPolicyEdit"

// 初めての方へ
import G0251FirstTimeList from "./components/jsx/G0251FirstTimeList";
import G0252FirstTimeEdit from "./components/jsx/G0252FirstTimeEdit";

// 輸出要件・規制一覧
import G0261RoadMapList from "./components/jsx/G0261RoadMapList";
import G0262RoadMapEdit from "./components/jsx/G0262RoadMapEdit";

import CustomizedSnackbar from "./components/jsx/CustomizedSnackbar";
import Header from "./components/jsx/Header";
import Footer from "./components/jsx/Footer";
import Login from "./components/jsx/Login";

export const MsgContext = createContext();

function App() {
  // エラーメッセージ
  const [msg, setMsg] = React.useState("");

  const msgValue = {
    msg,
    setMsg,
  };

  return (

    <div>
      {/* サブドメインを指定する場合はbasenameを指定する */}
      {/* <BrowserRouter basename="/maff"> */}
      {/* <BrowserRouter > */}
      <BrowserRouter basename="/" >
        <MsgContext.Provider value={msgValue}>
          {/* <Login /> */}
          <Header />
          <CustomizedSnackbar />
          <Routes>
            <Route path={"/"} element={<D001SearchTop />} />
            <Route path={"/D002SearchResult"} element={<D002SearchResult />} />
            <Route path={"/D003SearchDetail"} element={<D003SearchDetail />} />
            <Route path={"/D0041ContactTop"} element={<D0041ContactTop />} />
            <Route path={"/D0042ContactConfirm"} element={<D0042ContactConfirm />} />
            <Route path={"/D0043ContactComplete"} element={<D0043ContactComplete />} />
            <Route path={"/D00501QuestionList"} element={<D00501QuestionList />} />
            <Route path={"/D00502QuestionDetail"} element={<D00502QuestionDetail />} />
            <Route path={"/D00503QuestionSearchList"} element={<D00503QuestionSearchList />} />
            <Route path={"/D006FirstTime"} element={<D006FirstTime />} />
            <Route path={"/D007RoadMap"} element={<D007RoadMap />} />
            <Route path={"/D008UpdateLog"} element={<D008UpdateLog />} />
            <Route path={"/D010TermsService"} element={<D010TermsService />} />
            <Route path={"/D011PrivacyPolicy"} element={<D011PrivacyPolicy />} />
            <Route path={"/D0121RacTop"} element={<D0121RacTop />} />
            <Route path={"/D0122RacDetail"} element={<D0122RacDetail />} />
            <Route path={"/D0131FoodAdditive"} element={<D0131FoodAdditive />} />
            <Route path={"/D0141OperatingOrganization"} element={<D0141OperatingOrganization />} />

            <Route path={"/G009AdminLogin"} element={<G009AdminLogin />} />
            <Route path={"/G010QuarantineList"} element={<G010QuarantineList />} />
            <Route path={"/G011NewsList"} element={<G011NewsList />} />
            <Route path={"/G012NewsEdit"} element={<G012NewsEdit />} />
            <Route path={"/G0131PlantQuarantineList"} element={<G0131PlantQuarantineList />} />
            <Route path={"/G0132PlantQuarantineEdit"} element={<G0132PlantQuarantineEdit />} />
            <Route path={"/G0141AnimalQuarantineList"} element={<G0141AnimalQuarantineList />} />
            <Route path={"/G0142AnimalQuarantineEdit"} element={<G0142AnimalQuarantineEdit />} />
            <Route path={"/G0151RadioActiveList"} element={<G0151RadioActiveList />} />
            <Route path={"/G0152RadioActiveEdit"} element={<G0152RadioActiveEdit />} />
            <Route path={"/G016LinkMaster"} element={<G016LinkMaster />} />
            <Route path={"/G017InputWord"} element={<G017InputWord />} />
            <Route path={"/G0181StaffList"} element={<G0181StaffList />} />
            <Route path={"/G0182StaffEdit"} element={<G0182StaffEdit />} />
            <Route path={"/G0191ExportCountryList"} element={<G0191ExportCountryList />} />
            <Route path={"/G0192ExportCountryEdit"} element={<G0192ExportCountryEdit />} />
            <Route path={"/G0201Rac"} element={<G0201Rac />} />
            <Route path={"/G0202RacItemCommon"} element={<G0202RacItemCommon />} />
            <Route path={"/G0203RacCountry"} element={<G0203RacCountry />} />
            <Route path={"/G0204RacStdValue"} element={<G0204RacStdValue />} />
            <Route path={"/G0205RacPesticide"} element={<G0205RacPesticide />} />
            <Route path={"/G0206RacProduct"} element={<G0206RacProduct />} />
            <Route path={"/G0207RacExport"} element={<G0207RacExport />} />
            <Route path={"/G0208RacJa"} element={<G0208RacJa />} />
            <Route path={"/G0209RacEn"} element={<G0209RacEn />} />
            <Route path={"/G02010RacQuarantineList"} element={<G02010RacQuarantineList />} />
            <Route path={"/G02011RacQuarantineEdit"} element={<G02011RacQuarantineEdit />} />
            <Route path={"/G02012RacUpload"} element={<G02012RacUpload />} />
            <Route path={"/G02013RacPesticideProducts"} element={<G02013RacPesticideProducts />} />
            <Route path={"/G0211FoodAdditive"} element={<G0211FoodAdditive />} />
            <Route path={"/G0212EuAdditiveList"} element={<G0212EuAdditiveList />} />
            <Route path={"/G0213EuFoodCategoryList"} element={<G0213EuFoodCategoryList />} />
            <Route path={"/G0214EuFootnoteList"} element={<G0214EuFootnoteList />} />
            <Route path={"/G0215EuFoodAdditiveList"} element={<G0215EuFoodAdditiveList />} />
            <Route path={"/G0216EuCombinationList"} element={<G0216EuCombinationList />} />
            <Route path={"/G0217EuQuarantineList"} element={<G0217EuQuarantineList />} />
            <Route path={"/G0218EuQuarantineEdit"} element={<G0218EuQuarantineEdit />} />
            <Route path={"/G0221Question"} element={<G0221Question />}/>
            <Route path={"/G0222QuestionCategoryList"} element={<G0222QuestionCategoryList/>} />
            <Route path={"/G0223QuestionCategoryEdit"} element={<G0223QuestionCategoryEdit/>} />
            <Route path={"/G0224QuestionList"} element={<G0224QuestionList/>} />
            <Route path={"/G0225QuestionEdit"} element={<G0225QuestionEdit/>} />
            <Route path={"/G0231TermsServiceList"} element={<G0231TermsServiceList/>} />
            <Route path={"/G0232TermsServiceEdit"} element={<G0232TermsServiceEdit/>} />
            <Route path={"/G0241PrivacyPolicyList"} element={<G0241PrivacyPolicyList/>} />
            <Route path={"/G0242PrivacyPolicyEdit"} element={<G0242PrivacyPolicyEdit/>} />
            <Route path={"/G0251FirstTimeList"} element={<G0251FirstTimeList/>} />
            <Route path={"/G0252FirstTimeEdit"} element={<G0252FirstTimeEdit/>} />
            <Route path={"/G0261RoadMapList"} element={<G0261RoadMapList/>} />
            <Route path={"/G0262RoadMapEdit"} element={<G0262RoadMapEdit/>} />
          </Routes>
          <Footer />
          <Login />
        </MsgContext.Provider>
      </BrowserRouter>
    </div>

  )
}

export default App

export function Head() {
  return (
    <title>Hello World</title>
  )
}
